import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Form, Row, Col } from "react-bootstrap";
import axios from "axios";

function McqQuestion({ currentQuestionIndex, setCurrentQuestionIndex }) {
  const location = useLocation();
  const { assessmentId } = location.state || {};
  const [questions, setQuestions] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!assessmentId) {
      setError("Assessment ID is required to fetch questions.");
      return;
    }

    const fetchQuestions = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API}/getQuestionAnswer`,
          {
            params: { assessment_id: assessmentId },
          }
        );
        if (response.data?.success) {
          setQuestions(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch questions.");
        }
      } catch (err) {
        console.error("Error fetching questions:", err);
        setError("An error occurred while fetching questions.");
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, [assessmentId]);

  const handleAnswerChange = (answerId) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [currentQuestionIndex]: answerId,
    });
  };

  if (loading) {
    return <p>Loading questions...</p>;
  }

  if (error) {
    return <p className="text-danger">{error}</p>;
  }

  if (!questions.length) {
    return <p>No questions found for this assessment.</p>;
  }

  const currentQuestion = questions[currentQuestionIndex] || {};
  const currentAnswers = currentQuestion.answers || [];

  return (
    <div
      className="container p-3"
      style={{
        border: "2px solid #faceb1",
        borderRadius: "8px",
        fontFamily: "Manrope-Regular",
      }}
    >
      <Row className="mb-2">
        <Col md={10} className="d-flex justify-content-start">
          <h6 className="mb-4 fw-semibold">
            Q.{currentQuestionIndex + 1} {currentQuestion.question_text}
          </h6>
        </Col>
        <Col md={2} className="d-flex justify-content-end">
          <p className="fw-semibold">Total Questions: {questions.length}</p>
        </Col>
      </Row>

      {currentAnswers.map((answer) => (
        <div
          key={answer.answer_id}
          style={{
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            border: "1px solid #ddd",
            marginBottom: "10px",
          }}
        >
          <Form.Check
            type="radio"
            name={`question-${currentQuestionIndex}`}
            label={
              <span>
                {answer.answer_text}{" "}
                {answer.is_correct && (
                  <span style={{ color: "green", fontWeight: "bold" }}>
                   (Correct Answer)
                  </span>
                )}
              </span>
            }
            checked={
              selectedAnswers[currentQuestionIndex] === answer.answer_id ||
              (!selectedAnswers[currentQuestionIndex] && answer.is_correct)
            }
            onChange={() => handleAnswerChange(answer.answer_id)}
          />
        </div>
      ))}
    </div>
  );
}

export default McqQuestion;
